import React from 'react';
import './ResetRotation.css';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';


function ResetRotation({ map }) {
  const { t } = useTranslation();

  const handleResetRotation = () => {
    if (map) {
      map.getView().setRotation(0);
    }
  };

  return (
    <div className="ResetRotation">
      <Button
        className="ResetRotationButton"
        onClick={handleResetRotation}
        title={t('resetRotation.tooltip')}
        aria-label={t('resetRotation.tooltip')}
        text
        icon="fa-solid fa-compass"
      >
    
      </Button>
    </div>
  );
}

export default ResetRotation;
